import { render } from "./Usecase.vue?vue&type=template&id=4693d889"
import script from "./Usecase.vue?vue&type=script&lang=js"
export * from "./Usecase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__